import { render, staticRenderFns } from "./ItemCardList.vue?vue&type=template&id=3b7e8c84&scoped=true&lang=pug&"
import script from "./ItemCardList.vue?vue&type=script&lang=js&"
export * from "./ItemCardList.vue?vue&type=script&lang=js&"
import style0 from "./ItemCardList.vue?vue&type=style&index=0&id=3b7e8c84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7e8c84",
  null
  
)

export default component.exports